
<div class="wrapper" [class.menu_foldWrap]="menutoggle" (click)="onClickBody()" (mouseover)="onClickBody()">
  <section class="allmenuWrap">
    <header class="menu_header">
        <h1 class="hide">All menu</h1>
        <button type="button" class="btn_menu" (click)="toggleClass()">All menu fold</button>
    </header>
    <div class="menubox">
      <div class="menu_list">
        <nav>
          <ul>
            <li class="menu_home" routerLinkActive="on">
              <button [routerLink]="menuPath.HOM1000" type="button">
                <span>{{'COMMON.LABEL.HOME' | translate}}</span>
              </button>
            </li>
        
            <li *ngIf="isPermission(0)" class="menu_account" routerLinkActive="on">
              <button [routerLink]="menuPath.MCI1000" type="button">
                <span>{{'COMMON.LABEL.MERCHANT_INQUIRY' | translate}}</span>
              </button>
            </li>

            <li *ngIf="isPermission(1)" class="menu_user" routerLinkActive="on">
              <button [routerLink]="menuPath.UMG1000" type="button">
                <span>{{'COMMON.LABEL.USER_MANAGEMENT' | translate}}</span>
              </button>
            </li>

            <li *ngIf="isManagmentPermission()" class="menu_push" routerLinkActive="on">
              <button [routerLink]="menuPath.PUS1000" type="button">
                <span>{{'COMMON.LABEL.PUSH_MANAGEMENT' | translate}}</span>
              </button>
                
            <li class="menu_merchant" routerLinkActive="on">
              <button [routerLink]="menuPath.REG1000" type="button">
                <span>{{'COMMON.LABEL.REQUEST_NEW_MERCHANT' | translate}}</span>
              </button>
            </li> 
          </ul>
        </nav>
      </div>
    </div>
  </section>
  <section class="subWrap">
      <header class="headerWrap">
          <div class="userinfoWrap">
              <div class="logo"><span><img src="../../assets/images/@img_user_logo.png" alt="logo image" /></span></div>
              <div class="info_cont">
                  <strong class="name">{{ userInfo.userName }}</strong>
              </div>
          </div>
          <div class="utilmenuWrap">
              <div class="switch_language">
                  <label (click)="onChangeLanguage('en')">
                      <input type="radio" id="engLang" name="lang" [checked]="langCode==='en'" value="en" />
                      <span>English</span>
                  </label>
                  <label (click)="onChangeLanguage('km')">
                      <input type="radio" id="khLang" name="lang" [checked]="langCode==='km'" value="km" />
                      <span>ភាសាខ្មែរ</span>
                  </label>
              </div>
              <ul class="util_list">
                  <li><button type="button" class="btn_head_logout" (click)="logOut()"><span>Logout</span></button></li>
              </ul>
          </div>
      </header>
      <div>
          <router-outlet></router-outlet>
      </div>
      <footer class="footerWrap">
          <h1 class="logo">{{'GNB1000.LABEL.DGB' | translate}}</h1>
          <div class="cont">
              <p class="addr"
                  [innerHTML]="'GNB1000.LABEL.HEAD_OFFICE_IN_SANTHOR_MUK_ADDRESS_NO_68B_KAMPUCHEA_KROM_BLVD_SANGKAT_TEUK_LAAK1_KHAN_TOUL_KORK' | translate">
              </p>
              <div class="tel">
                  <dl>
                      <dt>{{'GNB1000.LABEL.TEL' | translate}} :</dt>
                      <dd>{{'GNB1000.LABEL.ZERO_TWO_THREE_5NINE_ZERO' | translate}}</dd>
                      <dt>{{'GNB1000.LABEL.MAIL' | translate}} :</dt>
                      <dd>{{'GNB1000.LABEL.INFO_ADD_DGBCAMBODIA_DOT_COM' | translate}}</dd>
                      <dt>{{'GNB1000.LABEL.FAX' | translate}} :</dt>
                      <dd>{{'GNB1000.LABEL.ZERO_TWO_THREE_2NINE_SIX_2ZERO_TWO' | translate}}</dd>
                  </dl>
              </div>
              <div class="branch">
                  {{'GNB1000.LABEL.BRANCH_LOCATION' | translate}}
              </div>

              <div class="copyright">
                  <p>© {{'GNB1000.LABEL.COPYRIGHT_DGB_SPECIALIZED_BANK_CAMBODIA_ALL_RIGHT_RESERVED' | translate}}</p>
                  <div class="btn_area">
                      <button type="button" (click)="contact()">
                          <span>{{'GNB1000.LABEL.CONTACT' | translate}}</span>
                      </button>
                      <button type="button" (click)="careers()">
                          <span>{{'GNB1000.LABEL.CAREERS' | translate}}</span>
                      </button>
                  </div>
              </div>
          </div>
      </footer>
  </section>
</div>